<!-- admin-allathletes.component.html -->

<div class="text-top">
    <div class="d-flex justify-content-between align-items-center w-100">
        <span>Area Atleti</span>
    </div>
</div>

<div class="welldone-card">
    <div class="welldone-card-filter">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
                <label for="athleteFilter" class="form-label">Atleta (Nome / Cognome)</label>
                <input id="athleteFilter" type="text" class="form-control" [(ngModel)]="athleteFilter"
                    [ngModelOptions]="{ standalone: true }">
            </div>

            <div class="col-12 col-md-6 col-lg-3">
                <label for="parentFilter" class="form-label">Genitore (Nome / Cognome)</label>
                <input id="parentFilter" type="text" class="form-control" [(ngModel)]="parentFilter"
                    [ngModelOptions]="{ standalone: true }">
            </div>
            
            <div class="col-12 col-md-6 col-lg-3">
                <label for="userFilter" class="form-label">Utente (Nome / Cognome / Email)</label>
                <input id="userFilter" type="text" class="form-control" [(ngModel)]="userFilter"
                       [ngModelOptions]="{ standalone: true }">
            </div>

            <div class="col-12 col-md-6 col-lg-3">
                <label class="form-label required">Azienda </label>
                <welldone-multiselect
                        [placeholder]="'Cerca il nome di un\'azienda'"
                        [settings]="usersDropdownSettings"
                        [data]="companies"
                        [(ngModel)]="selectedCompanies"
                >
                </welldone-multiselect>
            </div>

            <div class="col-12 text-right">
                <div style="margin-top: 10px;">
                    <button class="btn btn-default pull-right" (click)="resetFilters()">Reset</button>
                    <button class="btn btn-primary pull-right" (click)="filterSearch()">Cerca</button>
                </div>
            </div>
        </div>
    </div>
</div>

<br>

<ui-table #athletesTable table-title="Elenco Atleti">
    <ng-template #customHeader>
        <tr>
            <td></td>
            <td>Atleta</td>
            <td>Genitori</td>
            <td>Utente</td>
            <td>Società</td>
            <td>Azioni</td>
        </tr>
    </ng-template>

    <ng-template #customRow let-row="row">

        <tr>
            <td class="text-center align-middle">
                <ng-container *ngIf="row.status as status">
                    <span class="status-dot" [ngClass]="{
                            'status-active': status === 'active',
                            'status-pending': status === 'pendingCompanyApprovation',
                            'status-deleted': status === 'deleted'}" [attr.title]="status === 'active'
                                ? 'Attivo'
                                : status === 'pendingCompanyApprovation'
                                    ? 'In attesa di approvazione'
                                    : status === 'deleted'
                                        ? 'Eliminato'
                                        : ''"></span>
                </ng-container>
            </td>
            <td>
                {{ row.firstName }} {{ row.lastName }}
            </td>
            <td>
                <ng-container *ngIf="row.parents_array != null; else noParents">
                    {{ row.parents_array }}
                </ng-container>

                <ng-template #noParents>
                    <small>-</small>
                </ng-template>
            </td>
            <td>
                {{ row.user?.firstName }} {{ row.user?.lastName }}<br>
                <small *ngIf="row.user?.email">{{ row.user.email }}</small>
            </td>
            <td>
                <span *ngIf="row.company">
                    {{ row.company.name }}
                </span>
            </td>
            <td>
                <div class="d-flex justify-content-end">
                    <button type="button"
                            class="btn welldone-btn d-flex align-items-center justify-content-center"
                            (click)="deleteAtlete(row.id)"
                            title="Elimina atleta">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
        </tr>
    </ng-template>
</ui-table>
